import React, { useState, useEffect } from 'react';
import MmcArcadeSystem from './core/mmc_arcade_system';
import MmcGameRegistry from './core/mmc_game_registry';
import { autodiscovered_games } from './modules';
import './styles/mmc-reset.css';
import './App.css';

function App() {
  const [registry] = useState(new MmcGameRegistry());
  const [games, set_games] = useState([]);

  useEffect(() => {
    // Autodiscover and Register all games
    autodiscovered_games.forEach(({ manifest, component }) => {
      if (component) {
        registry.register_game(manifest, component);
        console.log(`[Arcade] System Loaded: ${manifest.id}`);
      }
    });

    const loaded_games = autodiscovered_games
      .filter(m => !!m.component)
      .map(m => ({ ...m.manifest, component: m.component }))
      .sort((a, b) => (a.order || 999) - (b.order || 999));

    set_games(loaded_games);
  }, [registry]);

  return (
    <div className="app">
      <MmcArcadeSystem games={games} registry={registry} />
    </div>
  );
}

export default App;